import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../constants/firebaseModular';
import { EnrollmentCampaign } from '../../types/Campaigns/EnrollmentCampaign';
import * as Sentry from '@sentry/browser';

export const getCampaignInfo = async (campaignId: string) => {
  if (!campaignId) {
    Sentry.captureMessage('Cannot retrieve campaign info in getCampaignInfo. No campaignId provided');
    console.error('Cannot retrieve campaign info in getCampaignInfo. No campaignId provided');
    return;
  }
  if (campaignId === 'unset') {
    Sentry.captureMessage('Cannot retrieve campaign info in getCampaignInfo. CampaignId is unset');
    console.error('CampaignId is unset');
    return;
  }
  const docRef = doc(db, 'campaigns', campaignId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data() as EnrollmentCampaign;
    return data;
  } else {
    Sentry.captureMessage(`No such document: ${campaignId}`);
    console.error(`No such document: ${campaignId}`);
    throw new Error(`No such document: ${campaignId}`);
  }
};
